export const LOAD_CABIN_CREW_FOR_SCHEDULING = 'LOAD_CABIN_CREW_FOR_SCHEDULING';
export const GET_CABIN_CREW_FOR_SCHEDULING = 'GET_CABIN_CREW_FOR_SCHEDULING';
export const CLEAR_CABIN_CREW_FOR_SCHEDULING = 'CLEAR_CABIN_CREW_FOR_SCHEDULING';